module.exports = __webpack_public_path__ + "img/20190924154033688.4824949f.jpg";